import { PageContent } from "../PageContentFactory/component";

// cleanup prop data ie remove unused objects
const getSections = (page) => {
    return page?.sections?.reduce((arr, section) => {
        const mainContent = section?.main?.content?.[0]
            ? [
                  ...section.main.content.filter(({ type }) =>
                      PageContent.TYPE_LIST.includes(type)
                  ),
              ]
            : [];
        const rightContent = section?.right?.content?.[0]
            ? [
                  ...section.right.content.filter(({ type }) =>
                      PageContent.TYPE_LIST.includes(type)
                  ),
              ]
            : [];
        if (!mainContent.length && !rightContent.length) {
            return arr;
        }

        const main = { layout: section?.main?.layout, content: mainContent };
        const right = { content: rightContent };
        return [...arr, [main, right]];
    }, []);
};

export default getSections;
